import React from 'react'
import styled from 'styled-components'
import clamp from 'lodash/clamp'
import PropTypes from 'prop-types'
import colors from '@rodeo-dev/legos/dist/themes/colors'
import FONTS from '../../../../theme/fonts'

const Wrap = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: ${colors.text.white};
  font-family: ${FONTS.robotoCondensed};
`

const Bar = styled.div`
  border-radius: 3px;
  background: ${colors.default.light};
  height: 3px;
  flex: 1;
  position: relative;
  margin-right: 10px;
`

const CompletedBar = styled.div`
  border-radius: 3px;
  left: 0;
  width: ${({ value }) => `${value}%`};
  position: absolute;
  height: 100%;
  background: ${({ showWarningColor }) => showWarningColor ? colors.error.main : colors.additional.main};
`

const ProgressBar = ({ value, showWarningColor }) => (
  <Wrap>
    <Bar>
      <CompletedBar value={clamp(value, 0, 100)} showWarningColor={showWarningColor && value > 100} />
    </Bar>
    <span>{value}%</span>
  </Wrap>
)

ProgressBar.propTypes = {
  value: PropTypes.number,
  showWarningColor: PropTypes.bool
}

ProgressBar.defaultProps = {
  value: 0,
  showWarningColor: false
}

export default ProgressBar
